import { useContext } from "react";
import { MerchantContext } from "../contexts/MerchantContext";

export function usePortalContext() {
  const context = useContext(MerchantContext);
  if (context === undefined)
    throw new Error("usePortalContext must be used within a MerchantProvider");
  return context;
}
